import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Transforms } from 'slate';
import { getTextAfterSymbol, insertMention } from './utils';
import { SelectMention } from './select-mention';
import { useMentionQuery } from './use-mention-query';
export const useMention = () => {
    const editorRef = React.useRef(null);
    const [target, setTarget] = React.useState(null);
    const [query, setQuery] = React.useState('');
    const [searchUsers, setSearchUsers] = React.useState(true);
    const [index, setIndex] = React.useState(0);
    const { users, loading, hasError } = useMentionQuery(query);
    const handleMentionSelection = (user) => {
        if (user && (editorRef === null || editorRef === void 0 ? void 0 : editorRef.current)) {
            target && Transforms.select(editorRef === null || editorRef === void 0 ? void 0 : editorRef.current, target);
            insertMention(editorRef === null || editorRef === void 0 ? void 0 : editorRef.current, user);
            // clear user selection to prevent blinking popover with previous query results
            setTarget(null);
            setQuery('');
        }
    };
    const handleMentionKeyEvent = React.useCallback((event, editor) => {
        editorRef.current = editor;
        if (event.key === '@')
            setSearchUsers(true);
        if (target && users.length) {
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    const nextIndex = index >= users.length - 1 ? 0 : index + 1;
                    setIndex(nextIndex);
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    const prevIndex = index <= 0 ? users.length - 1 : index - 1;
                    setIndex(prevIndex);
                    break;
                case 'Tab':
                case 'Enter':
                    event.preventDefault();
                    handleMentionSelection(users[index]);
                    break;
                case 'Escape':
                    event.preventDefault();
                    setTarget(null);
                    setSearchUsers(false);
                    break;
            }
        }
    }, [index, target, users]);
    const handleMentionOnChange = () => {
        if (editorRef.current) {
            const { query, range } = getTextAfterSymbol(editorRef.current);
            if (query && range && searchUsers) {
                setTarget(range);
                setQuery(query);
                setIndex(0);
            }
            else
                setTarget(null);
        }
    };
    // remove popover for empty result list
    React.useEffect(() => {
        if (!loading && !users.length)
            setTarget(null);
    }, [users, loading]);
    return {
        handleMentionKeyEvent,
        handleMentionOnChange,
        SelectMention: (restProps) => (_jsx(SelectMention, { ...restProps, target, editor: editorRef.current, popoverContentProps: {
                index,
                loading,
                onMouseDown: handleMentionSelection,
                users,
            } })),
    };
};
//# sourceMappingURL=use-mention.js.map